<template>
  <b-row :class="{'bg-light': index % 2 === 0}">
    <b-col v-for="(field, index) in tableFields" :key="'field' + index" :md="field.md">
      <slot :name="`field(${getFieldKey(field)})`" :row="form_data" />
    </b-col>

    <b-col md="1" class="d-flex justify-content-end">
      <b-button
        v-if="showSaveButton"
        variant="success"
        size="sm"
        class="mr-2"
        title="Save Changes"
        :disabled="!isFormEdited || savingForm"
        @click="save"
      >
        <i v-if="savingForm" class="fal fa-spinner fa-spin" />
        <i v-else class="fal fa-save" />
      </b-button>
      <b-button
        variant="danger"
        size="sm"
        @click="showDeleteModal"
      >
        <i class="fal fa-trash" />
      </b-button>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import { LabRepositoryFactory } from '@/repositories/lab/LabRepositoryFactory'
import { analyteRangeNotifications } from '@/shared/notifications'
import { notificationOptions } from '@/shared/toast-notification-options'

Vue.use(VueNotifications, notificationOptions)

const AnalyteRangeRepository = LabRepositoryFactory.get('analyteRange')

export default {
  name: 'AnalyteRangeFormRow',
  props: {
    item: {
      type: Object,
      required: true,
      default: () => null
    },
    fields: {
      type: Array,
      default: () => null
    },
    index: {
      type: Number,
      default: null
    },
    saveOnChange: {
      type: Boolean,
      default: true
    },
    showSaveButton: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      form_data: {
        ...this.item
      },
      
      savingForm: false
    }
  },
  computed: {
    tableFields () {
      return this.fields || (this.item && Object.keys(this.item))
    },

    isFormEdited () {
      return Object.keys(this.form_data).some((key) => this.form_data[key] != this.item[key])
    }
  },
  watch: {
    item (newVal) {
      this.form_data = { ...newVal }
    },
    form_data: {
      handler () {
        if (this.saveOnChange && this.isFormEdited) {
          this.debouncedSave()
        }
      },
      deep: true
    }
  },
  methods: {
    getFieldKey (field) {
      return field.name || field
    },

    showDeleteModal () {
      this.$bvModal
        .msgBoxConfirm(
          'You are about to remove this analyte range. Do you want to continue?',
          {
            title: 'Are you sure?',
            modalClass: ['modal-danger'],
            size: 'sm',
            okVariant: 'danger',
            okTitle: 'YES',
            cancelTitle: 'NO',
            footerClass: 'p-2',
            centered: true
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await AnalyteRangeRepository.suspend(this.item.id)

              this.deleteSuccess()
              this.$emit('refresh')
            } catch ({ response }) {
              const { status, data } = response.response

              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: 'Server Error.',
                variant: 'danger'
              })
            }
          }
        })
    },

    async save () {
      this.savingForm = true

      try {
        await AnalyteRangeRepository.update(this.item.id, this.form_data)

        this.editSuccess()
        this.$emit('refresh')
      } catch (error) {
        this.editFail()
      }

      this.savingForm = false
    },

    debouncedSave: _.debounce(function() {
      this.save()
    }, 500),
  },
  notifications: analyteRangeNotifications
}
</script>
